import {app} from '../../bootstrap/core';
import {adminState} from './admin.state';
import { adminComponent } from './admin.component';
import { RoleDescriptions } from './admin.constants';
import adminUserTablePartial from './partials/admin.user-table.tpl.html';

import '../../common/ui/userImport/userImport';

app.config(adminState);
app.component(adminComponent.name, adminComponent);
app.constant('adminUserTablePartial', adminUserTablePartial);
app.constant('roleDescriptions', RoleDescriptions);
